<template>
  <panel title="Search By Group">
    <v-text-field
      v-model="groupSearch"
      label="Search by group name"
    />
  </panel>
</template>

<script>
import _ from 'lodash'

export default {
	data () {
		return {
			groupSearch: ''
		}
	},
	watch: {
		groupSearch: _.debounce(async function (value) {
			const groupRoute = {
				name: 'groups'
			}
			if (this.groupSearch !== '') {
				groupRoute.query = {
					search: this.groupSearch
				}
			}
			this.$router.push(groupRoute)
		}, 700),
		'$route.query.search': {
			immediate: true,
			handler (value) {
				if (value) {
					this.groupSearch = value
				}
			}
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Groups/GroupsSearchPanel.vue